import {FLIGHT_ZOOM} from '@/config/map';
import {MOCK_TRACK_SQ247} from '@/config/mock';
import {useAppSelector} from '@/hooks/redux';
import {getFlightDetail, getTracks} from '@/services/flight-aware';
import moment from 'moment';
import {useEffect} from 'react';

const mockSQ247 = () => {
  const lastPoint = MOCK_TRACK_SQ247[MOCK_TRACK_SQ247.length - 1];
  const flightGeoJson = {
    type: 'Feature',
    properties: {
      type: 'aircraft',
      id: `SQ247_${moment.utc().format('YYYY-MM-DD')}`,
      rotation: 159
    },
    geometry: {
      type: 'Point',
      coordinates: [lastPoint.longitude, lastPoint.latitude]
    }
  };
  window.currentFlightPosition = flightGeoJson;
  window.updateData({
    event: 'aircraft-selected',
    data: [flightGeoJson]
  });
  window.updateData({
    event: 'camera',
    data: {
      center: [lastPoint.longitude, lastPoint.latitude],
      zoom: FLIGHT_ZOOM
    }
  });
  const coordinates = MOCK_TRACK_SQ247.map((route: any) => {
    return [route.longitude, route.latitude];
  });
  let prevLng = 0;
  const result = coordinates.map((item: any) => {
    let lng = item[0] as number;
    lng += lng - prevLng > 180 ? -360 : prevLng - lng > 180 ? 360 : 0;
    prevLng = lng;
    item[0] = lng;
    return item;
  });
  window.updateData({
    event: 'route',
    data: result
  });
};
const RouteLayer = () => {
  const flightDetail = useAppSelector((state) => state.flight.flightDetail);
  const isMockRunning =
    flightDetail?.flight_number === 'SQ247' &&
    moment.utc().isSameOrAfter(moment.utc('2025-02-27 11:40:00'));
  useEffect(() => {
    window.currentFlightPosition = null;
    if (!flightDetail) return;
    const getFlightTrack = async () => {
      window.updateData({
        event: 'route',
        data: []
      });
      const flightGeoJson = window.flightGeoJson.find(
        (item: any) => item.properties.id === flightDetail?.flight_id
      );
      let traffic = window?.allTraffic?.find(
        (i: any) => i.ident_iata === flightDetail.flight_number
      );
      if (!traffic) {
        const flights = flightDetail.flight_id.split('_');
        const flightInfo = await getFlightDetail(
          flightDetail.flight_number,
          flights[1]
        );
        traffic = flightInfo?.[0];
      }
      let lat = flightDetail.lat;
      let long = flightDetail.long;
      if (traffic?.last_position) {
        lat = traffic.last_position.latitude;
        long = traffic.last_position.longitude;
        flightGeoJson.geometry.coordinates = [long, lat];
      }
      const faFlightId = traffic.fa_flight_id;
      if (!faFlightId) {
        if (isMockRunning) {
          mockSQ247();
          return;
        }
        window.currentFlightPosition = flightGeoJson;
        window.updateData({
          event: 'aircraft-selected',
          data: [flightGeoJson]
        });
        window.updateData({
          event: 'camera',
          data: {
            center: [long, lat],
            zoom: FLIGHT_ZOOM
          }
        });
        return;
      }
      const tracks = await getTracks(faFlightId);
      const routes = tracks?.positions;
      window.currentFlightPosition = routes;
      if (!routes) {
        if (isMockRunning) {
          mockSQ247();
          return;
        }
        window.currentFlightPosition = flightGeoJson;
        window.updateData({
          event: 'aircraft-selected',
          data: [flightGeoJson]
        });
        window.updateData({
          event: 'camera',
          data: {
            center: [long, lat],
            zoom: FLIGHT_ZOOM
          }
        });
        return;
      }
      const pastPosition = routes[routes.length - 1];
      if (!pastPosition) {
        if (isMockRunning) {
          mockSQ247();
          return;
        }
        window.currentFlightPosition = flightGeoJson;
        window.updateData({
          event: 'aircraft-selected',
          data: [flightGeoJson]
        });
        window.updateData({
          event: 'camera',
          data: {
            center: [long, lat],
            zoom: FLIGHT_ZOOM
          }
        });
        return;
      }
      flightGeoJson.geometry.coordinates = [
        pastPosition.longitude,
        pastPosition.latitude
      ];
      window.currentFlightPosition = flightGeoJson;
      window.updateData({
        event: 'aircraft-selected',
        data: [flightGeoJson]
      });
      window.updateData({
        event: 'camera',
        data: {
          center: [pastPosition.longitude, pastPosition.latitude],
          zoom: FLIGHT_ZOOM
        }
      });
      const coordinates = routes.map((route: any) => {
        return [route.longitude, route.latitude];
      });
      let prevLng = 0;
      const result = coordinates.map((item: any) => {
        let lng = item[0] as number;
        lng += lng - prevLng > 180 ? -360 : prevLng - lng > 180 ? 360 : 0;
        prevLng = lng;
        item[0] = lng;
        return item;
      });
      window.updateData({
        event: 'route',
        data: result
      });
    };
    void getFlightTrack();
  }, [flightDetail]);

  return <></>;
};

export default RouteLayer;
